<div>
  <a mat-button class="btn btn-transparent" (click)="selectAllGroups()" [id]="appliancesAddButtonIdTag">
    <i class="fas fa-plus" aria-hidden="true"></i>
    {{ 'SELECT_ALL' | translate }}
  </a>
  <dcp-new-form-field-select-autocomplete
    [autoSelectBtnIdTag]="'RecipesModifyStepsAppGroupBtn'"
    [autoSelectLstIdTag]="'RecipesModifyStepsAppGroupLst'"
    class="form-field-xl"
    [allChoices]="(allChoices$ | async) || []"
    [selectedChoices]="(selectedChoices$ | async) || []"
    [selectAll$]="selectAllGroups$"
    [hint]="'CHANGE_DEFAULT' | translate"
    (selectedChoiceClick)="selectDefaultApplianceGroup($event)"
    (selectedChoicesChange)="updateChosenApplianceGroupsInForm($event)"
  >
  </dcp-new-form-field-select-autocomplete>
</div>
